module.exports = __webpack_public_path__ + "img/study.f9827c23.png";